import { render } from "./system-registration.vue?vue&type=template&id=bdf3907e&ts=true"
import script from "./system-registration.vue?vue&type=script&lang=ts"
export * from "./system-registration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__